<ng-container>
  <i *ngIf="this.fabrique" class="fas fa-utensils yoni-color space"  title="PLAT"></i>
  <i *ngIf="!this.fabrique" class="fas fa-apple-alt new-color space"  title="DENRÉE"></i>
</ng-container>
